import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

interface LocalizedEntry {
	language: string;
	value: string;
}

@Pipe({
	name: 'langValue',
})
export class LangValuePipe implements PipeTransform {
	private translate = inject(TranslateService);

	private normalizeLang(lang?: string): string | undefined {
		if (!lang) return undefined;
		const lower = lang.toLowerCase();
		// Normalize locales like en-US -> en
		return lower.includes('-') ? lower.split('-')[0] : lower;
	}

	transform<T extends LocalizedEntry>(
		arr: T[] | null | undefined,
		lang?: T['language'] | string
	): string {
		if (!Array.isArray(arr)) return '';

		// If no lang provided, infer from current app language
		let effectiveLang = this.normalizeLang(typeof lang === 'string' ? (lang as string) : undefined);
		if (!effectiveLang) {
			effectiveLang = this.normalizeLang(this.translate.currentLang) || 'en';
		}

		const found = arr.find((e) => this.normalizeLang(e?.language) === effectiveLang);
		return found?.value ?? '';
	}
}
